module.exports = __webpack_public_path__ + "img/33.1d5d0cdb.jpg";